module.exports = __webpack_public_path__ + "static/media/weikang2.12f41c5a.png";